var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showInfo && _vm.message != ""
    ? _c(
        "a",
        { staticClass: "labels no-shipping-info", attrs: { href: _vm.link } },
        [_vm._v(_vm._s(_vm.message))]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }